import gql from 'graphql-tag';

export const RESPONDENTS_SECTION_QUERY = gql`
  query gscDashboardRespondentInformation($accountId: ID!) {
    gscDashboardRespondentInformation(id: $accountId) {
      numberOfInternalRespondents
      numberOfExternalRespondents
      numberOfInternalRespondentsInFamily
      numberOfExternalRespondentsInFamily
      internalRespondentsLeft
      respondentDeletionRules {
        internalRespondentDeletionRule {
          type
          numberOfDaysToAnonymizeAfter
        }
        externalRespondentDeletionRule {
          type
          numberOfDaysToAnonymizeAfter
        }
      }
    }
  }
`;

export const QUESTIONNAIRE_SECTION_QUERY = gql`
  query gscDashboardQuestionnaireInformation($accountId: ID!) {
    gscDashboardQuestionnaireInformation(id: $accountId) {
      assessments {
        completedSinceLastLogin
        inProgress
        toExpireInTheNextSevenDays
        activeSuperLinks
      }
      jobProfileSurveys {
        completedSinceLastLogin
        inProgress
        toExpireInTheNextSevenDays
      }
      surveys {
        completedSinceLastLogin
        inProgress
        activeSuperSurveys
      }
    }
  }
`;

export const SUBSCRIPTION_SECTION_QUERY = gql`
  query gscDashboardSubscriptionInformation($accountId: ID!) {
    gscDashboardSubscriptionInformation(id: $accountId) {
      maximumNumberOfInternalRespondents
      willBeRenewedOn
    }
  }
`;

export const CREDITS_SECTION_QUERY = gql`
  query essentialAccountDashboardCreditsInformationQuery($accountId: ID!) {
    essentialAccountDashboardCreditsInformation(id: $accountId) {
      creditBalance
    }
  }
`;

export const CONTACT_SECTION_QUERY = gql`
  query gscDashboardContactsInformation($accountId: ID!) {
    gscDashboardContactsInformation(id: $accountId) {
      ownerEmail
      accountDataProtectionOfficerEmail
      gpiContactEmail
      gpiDataProtectionOfficerEmail
    }
  }
`;

export const DASHBOARD_QUERY = gql`
  query dashboardQuery($accountId: ID!) {
    account(id: $accountId) {
      id
      type
      isHeadOfFamily
      isCompanyInformationDifferentFromBillingInformation
      currentCreditPlan
      creditPlanExpirationDate
      companyInformation {
        country
      }
      subscriptionInformation {
        payedBy
        hasActiveSubscription
        currentSubscription {
          endsOn
          ninetyDaysAfterExpiration
        }
      }
      gpiRepresentativeData {
        parentAccountOwnerFullName
        parentAccountOwnerEmail
      }
      dashboard {
        assessmentsCount
        respondentsCount
        jobsByAssessmentTemplate
        jobsCount
        assessmentsByStatus
      }
      respondentData {
        internalRespondents {
          includedInPlan
          presentlyUsed
          deletionRule {
            type
            numberOfDaysToAnonymizeAfter
          }
        }
        externalRespondents {
          includedInPlan
          presentlyUsed
          deletionRule {
            type
            numberOfDaysToAnonymizeAfter
          }
        }
      }
    }
  }
`;

export const DOCUMENTS_TO_ACCEPT_QUERY = gql`
  query documentsToAcceptQuery($accountId: ID!) {
    account(id: $accountId) {
      id
      pendingDocumentChangeAcceptanceRequests {
        id
        documentId
        documentType
        documentUrl
      }
    }
  }
`;

export const DECLINED_DOCUMENTS_QUERY = gql`
  query declinedDocumentsQuery($accountId: ID!) {
    declinedDocuments(id: $accountId) {
      declinedDocumentChangeAcceptanceRequests {
        id
        documentId
        documentType
        documentUrl
      }
      isOwner
    }
  }
`;

export const ESSENTIAL_ACCOUNT_TO_BE_DELETED_NOTIFICATION_QUERY = gql`
  query essentialAccountToBeDeletedNotificationQuery($accountId: ID!) {
    essentialAccountToBeDeletedNotification(id: $accountId) {
      payedBy
      numberOfDaysUntilDeletion
      retentionPrice
      creditBalance
      canPayRetentionFee
      gpiRepresentative {
        parentAccountOwnerFullName
        parentAccountOwnerEmail
      }
    }
  }
`;

export const PAY_RETENTION_FEE_MUTATION = gql`
  mutation payRetentionFeeMutation($accountId: ID!) {
    payRetentionFee(id: $accountId) {
      account {
        id
      }
    }
  }
`;

export const ACCOUNT_ORGANISATION_SIZE_NOTIFICATION_QUERY = gql`
  query accountOrganisationSizeNotificationQuery($accountId: ID!) {
    accountOrganisationSizeNotification(id: $accountId) {
      id
    }
  }
`;

export const ACCOUNT_NO_ORGANISATION_SIZE_NOTIFICATION_QUERY = gql`
  query accountNoOrganisationSizeNotificationQuery($accountId: ID!) {
    accountNoOrganisationSizeNotification(id: $accountId) {
      id
    }
  }
`;

export const UPDATE_ACCOUNT_ORGANISATION_SIZE_NOTIFICATION_MUTATION = gql`
  mutation updateAccountOrganisationSizeNotificationMutation($input: UpdateAccountOrganisationSizeNotificationInput!) {
    updateAccountOrganisationSizeNotification(input: $input) {
      id
    }
  }
`;

export const UPDATE_ORGANISATION_SIZE_MUTATION = gql`
  mutation updateOrganisationSizeMutation($input: UpdateOrganisationSizeInput!) {
    updateOrganisationSize(input: $input) {
      account {
        id
      }
    }
  }
`;
